const state = {
  evollauth_server: process.env.VUE_APP_AUTH_URL,
  evollead_server: process.env.VUE_APP_LEADS_URL,
  ebooking_server: process.env.VUE_APP_EBOOKING_URL,
  homelab_server: process.env.VUE_APP_HOMELAB_URL,
  auth_clinical_server: process.env.VUE_APP_AUTH_CLINICAL_URL,
  evocall_server: process.env.VUE_APP_EVOCALL_URL,
  reports_server: process.env.VUE_APP_REPORTS_URL,
  optometry_server: process.env.VUE_APP_OPTOMETRY_URL,
  leads_web_server: process.env.VUE_APP_LEADS_WEB_URL,
  iframe_server: process.env.VUE_APP_IFRAME_URL,
  wellbeing_server: process.env.VUE_APP_WELLBEING_URL
}

const getters = {
  servers: state => {
    return [
      state.evollauth_server,
      state.evollead_server,
      state.ebooking_server,
      state.homelab_server,
      state.reports_server,
      state.auth_clinical_server,
      state.evocall_server,
      state.reports_server,
      state.optometry_server,
      state.leads_web_server,
      state.iframe_server,
      state.wellbeing_server
    ]
  }
}

export default {
  state,
  getters
}
